<template>
    <div class="flex flex-col items-start gap-3 w-full">
        <div class="flex items-center gap-2 w-full rounded">
            <Icon icon="verify" :class="iconClass" />
            <span :class="labelClass">
                {{ label }}
            </span>
            <label
                class="switch relative inline-block w-[42px] h-[25px] flex-shrink-0"
            >
                <input
                    class="opacity-0 w-0 h-0"
                    type="checkbox"
                    :checked="bonusAlertEnabled"
                    :disabled="bonusAlertLoading"
                    @change="$emit('toggle', $event.target.checked)"
                />
                <span
                    class="slider round absolute cursor-pointer inset-0 bg-gray-300 dark:bg-slate-600 transition duration-400 rounded-xl"
                ></span>
            </label>
        </div>

        <p :class="descriptionClass">
            <template v-if="isHeroDesktop">
                Don't miss {{ programName }} transfer bonuses. Get alerts at
            </template>
            <template v-else>
                Don't miss {{ programName }} best bonus deals. Get them at
            </template>
            <span class="font-semibold">{{ email || 'your email' }}</span>.
        </p>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import Icon from '@/components/ui/icon/icon.vue';

const props = defineProps({
    programName: { type: String, required: true },
    email: String,
    bonusAlertEnabled: Boolean,
    bonusAlertLoading: Boolean,
    variant: {
        type: String,
        default: 'desktop',
        validator: (v) => ['desktop', 'hero-desktop', 'mobile-sheet'].includes(v),
    },
});

defineEmits(['toggle']);

const isMobileSheet = computed(() => props.variant === 'mobile-sheet');
const isHeroDesktop = computed(() => props.variant === 'hero-desktop');

const iconClass = computed(() =>
    isMobileSheet.value ? 'w-6 h-6 text-slate-800 dark:text-slate-100' : 'w-5 h-5 text-slate-800 dark:text-slate-100'
);

const label = computed(() => {
    if (isHeroDesktop.value) {
        return props.bonusAlertEnabled ? 'Bonus alert enabled' : 'Bonus alert disabled';
    }
    return 'Enable bonus alert';
});

const labelClass = computed(() =>
    isMobileSheet.value
        ? 'text-slate-800 dark:text-slate-100 text-base font-medium leading-6 flex-1'
        : 'text-slate-800 dark:text-slate-100 text-sm font-medium leading-5 flex-1'
);

const descriptionClass = computed(() =>
    isMobileSheet.value
        ? 'self-stretch text-slate-800 dark:text-slate-100 text-base font-normal leading-6'
        : 'text-slate-800 dark:text-slate-100 text-sm font-normal leading-5 w-full'
);
</script>

<style scoped>
.slider {
    border-radius: 25px;

    &:before {
        position: absolute;
        content: '';
        height: 19px;
        width: 19px;
        left: 3px;
        bottom: 3px;
        background-color: white;
        border-radius: 50%;
        box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
    }
}

input:focus + .slider:before,
input:active + .slider:before,
.switch:hover .slider:before {
    transition: 0.3s ease-in-out;
}

input:checked + .slider {
    background-color: #fd421d;

    &:before {
        transform: translateX(17px);
    }
}
</style>
